import Phaser from "phaser";
import { Player } from "../entities/player/Player";

export class EnemyProjectile extends Phaser.Physics.Arcade.Image {
  private lifeMs = 2200;
  private consumed = false;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    angle: number,
    private readonly damageAmount: number,
  ) {
    super(scene, x, y, "boss-projectile");
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setScale(0.23).setTint(0xb7d8ff).setBlendMode(Phaser.BlendModes.ADD);
    this.setDepth(Math.round(y) + 10);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setCircle(14);
    body.setVelocity(Math.cos(angle) * 390, Math.sin(angle) * 390);
  }

  override update(delta: number, player: Player): void {
    if (!this.active) return;
    this.lifeMs -= delta;
    this.setDepth(Math.round(this.y) + 10);
    if (this.lifeMs <= 0) {
      this.destroy();
      return;
    }
    if (!this.consumed && player.active && Phaser.Math.Distance.Between(this.x, this.y, player.x, player.y) < 30) {
      this.consumed = true;
      player.damage(this.damageAmount);
      this.destroy();
    }
  }
}
